module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-navbar"
  }, [_c('n3-nav', {
    staticClass: "nav-box",
    style: ({
      width: '180px',
      maxHeight: _vm.navHeight
    }),
    attrs: {
      "default-active": _vm.$route.path,
      "theme": "dark",
      "default-openeds": _vm.openedIndexList,
      "router": ""
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('n3-sub-nav', {
      key: item.id,
      attrs: {
        "index": item.path
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('n3-icon', {
      attrs: {
        "type": item.icon || 'bars'
      }
    }), _vm._v(_vm._s(item.label))], 1), _vm._v(" "), _vm._l((item.list), function(i, subIndex) {
      return _c('n3-nav-item', {
        key: i.path,
        attrs: {
          "index": i.path
        }
      }, [_vm._v(_vm._s(i.label))])
    })], 2)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d7195d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/navbar.vue
// module id = 310
// module chunks = 3